var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0287 1.66667C5.3992 0.669095 6.38885 0.0016741 7.5 0C8.6117 0.000761905 9.60234 0.668524 9.97285 1.66667H11V5H4V1.66667H5.0287ZM0 18.8333V3H2.45455V6.16667H12.2727V3H14.7273V7.75H18V22H4.90909V18.8333H0ZM7 10H16V20H7V10ZM8 13V11H15V13H8ZM8 14V16H15V14H8ZM8 19V17H15V19H8Z",
    fill: "#003D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.1e1e52a425887cf145fbad5397d2f0ee.svg";
export { ForwardRef as ReactComponent };